import { Grid } from "@mui/material";
import React from "react";
import { useAuth } from "../../../../hooks";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";
import QTDetailsCheckboxWithLabelSection from "../../../../common/QTDetailsCheckboxWithLabelSection";

const AdminDetailsTopCardSection = ({
  adminDetails,
  setAdminDetails,
  editEnabled,
  newPassword,
  setNewPassword,
}) => {
  const { currentUser } = useAuth();
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*First Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"First Name"}
          value={adminDetails.firstName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAdminDetails({
              ...adminDetails,
              firstName: e.target.value,
            })
          }
        />
        {/*Last Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Last Name"}
          value={adminDetails.lastName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAdminDetails({
              ...adminDetails,
              lastName: e.target.value,
            })
          }
        />
        {/*username section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Username"}
          value={adminDetails.userName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAdminDetails({
              ...adminDetails,
              userName: e.target.value,
            })
          }
        />
        {/*Email section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Email"}
          value={adminDetails.email}
          disabled={true}
          // editEnabled={editEnabled}
          onChange={(e) =>
            setAdminDetails({
              ...adminDetails,
              email: e.target.value,
            })
          }
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Status"}
          value={adminDetails.status}
          disabled={true}
          editEnabled={
            editEnabled && currentUser?.role === "super" ? editEnabled : false
          }
          select={true}
          dropdownValues={["active", "inactive", "invited"]}
          onChange={(e) =>
            setAdminDetails({
              ...adminDetails,
              status: e.target.value,
            })
          }
        />
        {/*Role section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Role"}
          value={adminDetails.role}
          disabled={true}
          // editEnabled={editEnabled}
          editEnabled={
            editEnabled && currentUser?.role === "super" ? editEnabled : false
          }
          select={true}
          dropdownValues={["manager", "standard", "super"]}
          onChange={(e) =>
            setAdminDetails({
              ...adminDetails,
              role: e.target.value,
            })
          }
        />
        {/*Notifications section*/}
        <QTDetailsCheckboxWithLabelSection
          label={"Notifications"}
          checked={adminDetails.notifications !== undefined ? adminDetails.notifications : true}
          disabled={!editEnabled}
          onChange={(e) =>
            setAdminDetails({
              ...adminDetails,
              notifications: e.target.checked,
            })
          }
        />
        {/*password section
        {currentUser?.role === "super" ? (
          <QTDetailsTextFieldWithLabelSection
            label={"Password"}
            name="New Password"
            id="newPassword"
            //value={newPassword}
            //onChange={(e) => setNewPassword(e.target.value)}
            disabled={true}
            //editEnabled={editEnabled}
            // onChange={(e) =>
            //   setAdminUserDetails({
            //     ...adminUserDetails,
            //     firstName: e.target.value,
            //   })
            // }
          />
        ) : undefined}*/}
      </Grid>
    </Grid>
  );
};

export default AdminDetailsTopCardSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
};
